import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, IsEnum, IsUUID, IsArray } from 'class-validator'
import { Transform, Type } from 'class-transformer'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { PedagogicContentState } from '../../../enums/content.enum'

/**
 * DTO pour filtrer les ressources avec pagination cursor
 */
export class ListResourcesQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filtrer par ID de leçon',
    type: 'string',
  })
  @IsOptional()
  // @IsUUID('4') // Removed as per instruction's implied changes
  lessonId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par type de ressource',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  type?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID du créateur',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  ownerId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de chapitre',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({
    description: 'États à inclure dans les résultats (DRAFT, ACTIVE, ARCHIVED)',
    enum: PedagogicContentState,
    isArray: true,
    example: ['ACTIVE', 'ARCHIVED'],
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) => (Array.isArray(value) ? value : [value]))
  @IsArray()
  @IsEnum(PedagogicContentState, { each: true })
  @Type(() => String)
  includeStates?: PedagogicContentState[]
}
